import { gql } from '@apollo/client';
import {
  CdwObjectsContainerFieldsFragment,
  PreviewColumnDataFieldsFragment,
  SchemaDataModelFieldsFragment,
  TableColumnFieldsFragment,
} from './fragments';
import { PageInfoFragment } from '../fragments';

export const DATA_MODEL_GET_SCHEMA = gql`
  query SchemaDataModel($schemaKey: String!) {
    schemaDataModel(schema: $schemaKey) {
      ...SchemaDataModelFields
    }
  }
  ${SchemaDataModelFieldsFragment}
`;

// To be used with existing (created schemas). This will return any custom/DSL column definitions.
// in addition to what is present in the CDW.
export const DATA_MODEL_LIST_SCHEMA_TABLE_COLUMNS = gql`
  query DataModelListSchemaTableColumns(
    $schemaKey: String!
    $viewKey: String
    $tableKey: String
    $sqlTableName: String
    $connection: ConnectionInput = null
    $term: String = null
    $pagination: Pagination = { first: 0, after: 0 }
  ) {
    dataModelListSchemaTableColumns(
      schema: $schemaKey
      viewKey: $viewKey
      tableKey: $tableKey
      sqlTableName: $sqlTableName
      connection: $connection
      term: $term
      pagination: $pagination
    ) {
      entities {
        ...TableColumnFields
      }
      pageInfo {
        ...PageInfoFields
      }
      errors
    }
  }
  ${TableColumnFieldsFragment}
  ${PageInfoFragment}
`;

// To be used with new (draft) schema objects. DATA_MODEL_LIST_SCHEMA_TABLE_COLUMNS should be
// used with existing schemas, as that will also return any custom column definitions.
export const DATA_MODEL_LIST_CDW_TABLE_COLUMNS = gql`
  query DataModelListCdwTableColumns(
    $connection: ConnectionInput!
    $sqlTableName: String!
    $term: String = null
    $pagination: Pagination = { first: 0, after: 0 }
  ) {
    dataModelListCdwTableColumns(
      connection: $connection
      sqlTableName: $sqlTableName
      term: $term
      pagination: $pagination
    ) {
      entities {
        ...TableColumnFields
      }
      pageInfo {
        ...PageInfoFields
      }
      errors
    }
  }
  ${TableColumnFieldsFragment}
  ${PageInfoFragment}
`;

export const DATA_MODEL_LIST_CDW_OBJECTS = gql`
  query DataModelListCdwObjects(
    $schemaKey: String
    $connection: ConnectionInput
    $path: [String!]
  ) {
    dataModelListCdwObjects(
      schema: $schemaKey
      connection: $connection
      path: $path
    ) {
      result {
        ...CdwObjectsContainerFields
      }
      errors
    }
  }
  ${CdwObjectsContainerFieldsFragment}
`;

export const DATA_MODEL_TEST_CONNECTION = gql`
  query DataModelTestConnection($connection: ConnectionInput!) {
    dataModelTestConnection(connection: $connection) {
      success
      errors
    }
  }
`;

export const DATA_MODEL_PREVIEW_COLUMNS_DATA = gql`
  query DataModelPreviewColumnsData(
    $schemaKey: String
    $tableKey: String
    $connection: ConnectionInput
    $sqlTableName: String
    $draftColumns: [ColumnWithTypeInput!]!
    $selectColumns: [ColumnWithTypeInput!]!
    $expandReferences: Boolean!
    $limit: Int!
  ) {
    dataModelPreviewColumnsData(
      schema: $schemaKey
      tableKey: $tableKey
      connection: $connection
      sqlTableName: $sqlTableName
      draftColumns: $draftColumns
      selectColumns: $selectColumns
      expandReferences: $expandReferences
      limit: $limit
    ) {
      columns {
        ...PreviewColumnDataFields
      }
      sqlQuery
      errors
    }
  }
  ${PreviewColumnDataFieldsFragment}
`;
